import { CustomEventName } from '@/constants';
import { resetGTMDataLayer, pushEvent } from '..';

export const gtmTrackingWidget = (): void => {
  resetGTMDataLayer();
  pushEvent(CustomEventName.ParcelsTracked);
};
